<template>
  <article :class="classCard" class="p-dashboard-card">
    <div class="dashboard-card" :class="classCardWrapper">
      <div class="dashboard-card-header">
        <div class="d-flex align-items-center">
          <slot name="icon" />
          <h3 class="dashboard-card-title" :style="title">{{ title }}</h3>
        </div>

        <div v-if="withFilters" @click="openedFilters = !openedFilters" class="dashboard-card-filters">
          {{ selectedFilter ? selectedFilter.name : '' }}
          <span v-if="selectedFilter" class="mod-icon-chevron-down" />

          <div v-if="openedFilters" class="filters-list">
            <div v-for="(filter, index) in filters" @click="selectFilter(filter)" :key="index" class="filter-option">{{ filter.name }}</div>
          </div>
        </div>
      </div>

      <div class="dashboard-card-body mt-3">
        <slot name="body" />
      </div>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    withFilters: {
      type: Boolean,
      default: true,
    },
    classCard: {
      type: String,
      default: '',
    },
    classCardWrapper: {
      type: String,
      default: '',
    },
    selectedFilter: {
      type: Object,
      default: () => ({}),
    },
    filters: {
      type: Array,
      default: () => [],
    },
    titleStyle: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      openedFilters: false,
    };
  },
  methods: {
    selectFilter(filter) {
      this.$emit('set-filter', filter);
    },
  },
};
</script>

<style scoped lang="scss">
.p-dashboard-card {
  padding: 10px;
}

.dashboard-card {
  padding: 1.5rem;
  background-color: white;
  border-radius: 15px;

  .dashboard-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .dashboard-card-title {
      font-size: 16px;
      font-weight: bold;
      color: #45464e;
    }

    .dashboard-card-filters {
      font-size: 12px;
      color: #c7c5c5;
      position: relative;
      cursor: pointer !important;
      display: flex;
      align-items: center;

      .filters-list {
        position: absolute;
        top: 25px;
        right: 0;
        width: 110px;
        border-radius: 3px;
        border: 1px solid #e0e0e0;
        z-index: 1000;
        background-color: white;

        .filter-option {
          padding: 5px;
          border-bottom: 1px solid #e0e0e0;
          cursor: pointer !important;
          width: 100%;
          height: 30px;
          color: #525252;
        }

        .filter-option:last-child {
          border-bottom: 0 !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/salesDashboard/subcomponents/SalesDashboardCard.vue